module.exports = __webpack_public_path__ + "img/icon-myinfo-lock.78c3294a.svg";